import { useUnit } from 'effector-react'

import { $portalProfile } from '@/entities/profile/portal'
import { env } from '@/shared/config'

import { VersionBadge } from '../version-badge/view'

export type BuildVersionProps = {
    className?: string
}

export function BuildVersionInfo({ className }: BuildVersionProps) {
    const profile = useUnit($portalProfile)

    if (profile?.tester !== true) {
        return null
    }

    return <VersionBadge label="Portal" value={env.BUILD_VERSION} className={className} />
}
